import React, { useEffect, useState } from 'react';

const ScreenSizeWarning = () => {
  const [isScreenTooSmall, setIsScreenTooSmall] = useState<boolean>(false);

  useEffect(() => {
    const checkScreenSize = () => {
      setIsScreenTooSmall(
        window.innerHeight < 300 || window.innerWidth < 250
      );
    };

    checkScreenSize();
    window.addEventListener('resize', checkScreenSize);
    return () => window.removeEventListener('resize', checkScreenSize);
  }, []);

  if (!isScreenTooSmall) {
    return null;
  }

  return (
    <div className="fixed top-0 left-0 w-full h-screen flex flex-col items-center justify-center bg-[var(--background-main)] z-[var(--z-modal)] p-8 text-center">
      <h1 className="text-2xl font-bold text-[var(--text-primary)] mb-4 leading-tight">
        Screen Size Too Small
      </h1>
    </div>
  );
};

export default ScreenSizeWarning;